export default __webpack_public_path__ + "static/media/t2.min.8212e914.png";